import { render, staticRenderFns } from "./contractManagement.vue?vue&type=template&id=5637179c"
import script from "./contractManagement.vue?vue&type=script&lang=js"
export * from "./contractManagement.vue?vue&type=script&lang=js"
import style0 from "./contractManagement.vue?vue&type=style&index=0&id=5637179c&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports